import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getIsOpPro, getIsSuperuser } from "modules/account-root/selectors"
import { getResourceType, getTabs, getResourceId, getResourceMembers, getAccountMembers, getPermissionLevel } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    userId: props.params.userId,
    resourceAlias: props.params.resourceAlias,
    resourceType: getResourceType(state, props),
  }),
  required: ["account", "resourceAlias", "resourceType"],
  data: [{
    resource: "resourceMembers",
    passthrough: true,
    url: ({ resourceAlias, resourceType }) => {
      return {
        id: `resource-members-${resourceAlias}`,
        query: `query($resourceAlias:IdOrShortIdOrAlias!, $resourceType: ResourceType!){
          resource(id:$resourceAlias, type:$resourceType){
            id
            name
            alias
            type
            permissionLevel
            members {
              id
              name
              email
              permissionLevel
              createdAt
            }
          }
        }`,
        variables: {
          resourceAlias,
          resourceType,
        },
      }
    },
  },
  {
    resource: "accountMembers",
    passthrough: true,
    url: ({ account }) => {
      return {
        id: `account-members-${account}`,
        query: `query{
            members{
              id
              name
              createdAt
            }
        }`,
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    resourceId: getResourceId(state, props),
    resourceMembers: getResourceMembers(state, props),
    accountMembers: getAccountMembers(state, props),
    permissionLevel: getPermissionLevel(state, props),
    role: getRole(state),
    isOpPro: getIsOpPro(state),
    isSuperuser: getIsSuperuser(state),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
